





















































import { Vue, Component } from "vue-property-decorator";
import TuitionTutorial from "@/components/business/tutorial/TuitionTutorial.vue";
import TutorialBtn from "@/components/business/tutorial/TutorialBtn.vue";
import safety from "@/assets/safety-logo.png";
import riskControl from "@/assets/risk-control-logo.png";
import {device} from '@/util/mediaCheck'

@Component({
  components: {
    TuitionTutorial,
    TutorialBtn,
  },
})
export default class Tuition extends Vue {
  public device = device;
  title = this.$t("留学汇款<br/>从未如此简单");
  features = [
    this.$t("全线上操作，3分钟完成缴费流程"),
    this.$t("已覆盖全球主流地区超百所院校"),
    this.$t("资金足额到账无损耗，实惠省心"),
    this.$t("不占用个人年度5万美元购汇额度"),
  ];
  endorsements = [
    {
      img: safety,
      content: this.$t("支持微信支付<br/>每笔交易多重安全检测"),
    },
    {
      img: riskControl,
      content: this.$t("智能风控系统<br/>多道合规防线层层把关"),
    },
  ];
  // 是否展示汇款攻略
  isShowTutorial = false;
  onTutorialClick() {
    this.isShowTutorial = true;
  }

  // 点击关闭弹窗
  handleCloseDialog() {
    this.isShowTutorial = false;
  }
}
